export const HOT_NOTE_MAX_CHARS = 500;
export const HOT_NOTE_BG_COLOR = '#fff9e6';
export const HOT_NOTE_LABEL = 'Hot Note';
export const ADD_HOT_NOTE_LABEL = 'Add Hot Note';
